module.exports = __webpack_public_path__ + "img/9788973818303.f2347c2e.jpg";